import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class BuscaCepService {

    getCep(cep: any) {
        return new Observable((x) => {
            var request = new XMLHttpRequest();
            request.open('get', `https://viacep.com.br/ws/${cep}/json/`, true);
            request.send();
            request.onload = function () {
                var data = JSON.parse(this.response);
                x.next(data);
            }
        });
    }

}
